import { render, staticRenderFns } from "./managementHuoWu.vue?vue&type=template&id=49bb2c47&scoped=true&"
import script from "./managementHuoWu.vue?vue&type=script&lang=js&"
export * from "./managementHuoWu.vue?vue&type=script&lang=js&"
import style0 from "./managementHuoWu.vue?vue&type=style&index=0&id=49bb2c47&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb2c47",
  null
  
)

export default component.exports